import Link from "next/link";
import { usePathname } from "next/navigation";
import classNames from "classnames";
import { useCopyToClipboard } from "@shared/lib/hooks/useCopyToClipboard";
import { CopyLinkIcon } from "@shared/ui/Icon/ui/Socials/CopyLinkIcon";
import { TelegramIcon } from "@shared/ui/Icon/ui/Socials/TelegramIcon";
import { VkIcon } from "@shared/ui/Icon/ui/Socials/VkIcon";
import { TELEGRAM_SHARE_URL, VK_SHARE_URL } from "./constants";
import { BlogShareProps } from "./types";
import classes from "./blog-share.module.scss";

export const BlogShare = ({ className }: BlogShareProps) => {
    const pathname = usePathname();
    const productLink = `${process.env.NEXT_PUBLIC_DOMAIN}${pathname}`;
    const [copiedUrl, copyUrlToClipboard] = useCopyToClipboard(productLink);

    return (
        <div className={classNames(classes["blog-share"], className)}>
            <Link
                className={classes["blog-share__item"]}
                href={`${VK_SHARE_URL}${productLink}`}
                rel="nofollow noreferrer"
                target="_blank"
            >
                <VkIcon className={classes["blog-share__social"]} />
            </Link>
            <Link
                className={classes["blog-share__item"]}
                href={`${TELEGRAM_SHARE_URL}${productLink}`}
                rel="nofollow noreferrer"
                target="_blank"
            >
                <TelegramIcon className={classes["blog-share__social"]} />
            </Link>
            <div className={classes["blog-share__item"]} onClick={() => copyUrlToClipboard()}>
                <CopyLinkIcon
                    className={classNames(classes["blog-share__copy"], {
                        [classes["blog-share__copy--active"]]: copiedUrl
                    })}
                />
            </div>
        </div>
    );
};